import React from "react"
import { Grid } from "@mui/material"
import { UploadCsvButton, UploadCsvTemplate } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { ReportFormDrawerCsvTable } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Csv"
import { useUploadCsv } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportFormDrawerCsvSection() {

	const { data, onDownload, onDelete, onSubmit } = useUploadCsv()

	return <Grid container spacing={2}>
		<Grid item xs={1}>
			<UploadCsvButton {...data} onSubmit={onSubmit}/>
		</Grid>
		<Grid item xs={1}>
			<UploadCsvTemplate />
		</Grid>
		<Grid item xs={5}>
			<ReportFormDrawerCsvTable {...data} onDownload={onDownload} onDelete={onDelete}/>
		</Grid>
	</Grid>
}